import { notFound } from '@tanstack/react-router'
import { REALMS, type Realm } from '../vocabulary'

export const realmOf = (raw: string): Realm => {
  if (!REALMS.includes(raw as Realm)) throw notFound()

  return raw as Realm
}
